// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import styles from "./resolverGroup.scss";
import { createGroupSubmit } from "./resolverGroupRedux/resolverGroupActionCreator";
import { getTicketingUsers } from "../buSettings/buSettingsRedux/buSettingsActionCreator";
import { getGroupTypesByBu } from "../categorySettings/categorySettingsRedux/categorySettingsActionCreator";
import SelectWithAdd from "../../../commons/formElements/selectWithAdd/selectWithAdd";
import BasicSelect from "../../../commons/formElements/basicSelect/basicSelect";

type Props = {
  createGroupSubmit: Function,
  resolverGroupState: Object,
  categorySettingsState: Object,
  userProfile: Object,
  getGroupTypesByBu: Function,
  location: Object,
  group?: Object,
  onBack: Function,
  getTicketingUsers: Function,
  buSettingsState: Object
};

type State = {
  groupLead: string,
  escalationMatrix: Object,
  groupType: string
};

const escalationLevelMap = {
  LEVEL_ONE: null,
  LEVEL_TWO: null,
  LEVEL_THREE: null,
  LEVEL_FOUR: null
};

class ResolverGroup extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      groupLeadId: this.props.group ? this.props.group.groupLeadId : null,
      escalationMatrix: this.props.group
        ? this.getEscalationMatrix(this.props.group.escalationMatrix)
        : Object.assign({}, escalationLevelMap),
      groupTypeId: this.props.group ? this.props.group.groupTypeId : null,
      userIdList: this.props.group ? this.props.group.userIdList : [],
      showGroupLeadOptions: false,
      showEscalationOptionsArr: [false, false, false, false, false]
    };
  }

  componentDidMount() {
    this.props.getGroupTypesByBu(
      this.props.userProfile.business_unit &&
        this.props.userProfile.business_unit.id
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.group !== this.props.group) {
      this.setState({
        groupLeadId: nextProps.group ? nextProps.group.groupLeadId : null,
        escalationMatrix: nextProps.group
          ? this.getEscalationMatrix(nextProps.group.escalationMatrix)
          : Object.assign({}, escalationLevelMap),
        groupTypeId: nextProps.group ? nextProps.group.groupTypeId : null,
        userIdList: nextProps.group ? nextProps.group.userIdList : []
      });
    } else if (
      this.props.resolverGroupState.group.isLoading &&
      nextProps.resolverGroupState.group.isLoaded &&
      nextProps.resolverGroupState.group.data
    ) {
      this.props.onBack();
    }
  }

  onSubmit() {
    if (!this.state.groupTypeId) {
      toastr.error("Please select group type");
      return;
    }
    if (this.props.location.locationCode === "HQTR") {
      if (!this.state.groupLeadId) {
        toastr.error("Please select group lead");
        return;
      }
      if (!this.state.userIdList || !this.state.userIdList.length) {
        toastr.error("Please select users for the group");
        return;
      }
    }
    const formData = {
      id: this.props.group ? this.props.group.id : null,
      locationCode: this.props.location.locationCode,
      locationId: this.props.location.locationId,
      groupTypeId: this.state.groupTypeId,
      groupLeadId:
        this.props.location.locationCode === "HQTR"
          ? this.state.groupLeadId
          : null,
      isActive: this.props.group ? this.props.group.isActive : null,
      escalationMatrix:
        this.props.location.locationCode === "HQTR"
          ? this.state.escalationMatrix
          : this.props.escalationMap || {},
      userIdList:
        this.props.location.locationCode === "HQTR"
          ? this.state.userIdList
          : this.props.memberUserIds || []
    };
    this.props.createGroupSubmit(formData, this.props.group);
  }

  getUserOptions(data) {
    return data.map(user => ({
      key: user.name ? `${user.name} ${user.email}` : user.email,
      val: user.email ? user.email : user.name,
      id: user.id
    }));
  }

  getEscalationMatrix(escalation) {
    return Object.assign(Object.assign({}, escalationLevelMap), escalation);
  }

  getGroupTypeOptions(groupTypes) {
    const arrToReturn = [];
    if (groupTypes.isLoaded && groupTypes.data) {
      groupTypes.data.forEach(option => {
        if (this.props.location.locationCode === "HQTR") {
          if (option.locationType === "HQTR") {
            arrToReturn.push({
              key: option.name,
              val: option.name,
              id: option.id
            });
          }
        } else if (option.locationType === "OU") {
          arrToReturn.push({
            key: option.name,
            val: option.name,
            id: option.id
          });
        }
      });
    }
    return arrToReturn;
  }

  setEscalationState(val, level) {
    const escalationMatrix = Object.assign({}, this.state.escalationMatrix);
    escalationMatrix[level] = new Array(1);
    escalationMatrix[level][0] = val;
    this.setState({
      escalationMatrix
    });
  }

  renderEscalationForm() {
    const { ticketingUsers } = this.props.buSettingsState;
    return (
      <div>
        {Object.keys(this.state.escalationMatrix).map(level => (
          <div
            key={level}
            className={`l-row a-center j-center ${styles.escalationWrapper}`}
          >
            <div className="flex-30">
              <h2>{level.replace("_", " ")}</h2>
            </div>
            {this.props.location.locationCode === "HQTR" ? (
              <div className={`${styles.escalationSelect}`}>
                <BasicSelect
                  optionsArrOfObj={
                    ticketingUsers.isLoaded
                      ? this.getUserOptions(ticketingUsers.data)
                      : []
                  }
                  displayNone={true}
                  selectedOpt={
                    this.props.group
                      ? this.state.escalationMatrix[level] &&
                        this.state.escalationMatrix[level][0]
                      : null
                  }
                  onSelect={newValue => {
                    const showEscalationOptionsArr = Object.assign(
                      [],
                      this.state.showEscalationOptionsArr
                    );
                    showEscalationOptionsArr[level] = false;
                    this.setState({ showEscalationOptionsArr }, () =>
                      this.setEscalationState(newValue, level)
                    );
                  }}
                  label="Select Email address"
                  enableSearch={true}
                  onChangeInput={val => {
                    const showEscalationOptionsArr = Object.assign(
                      [],
                      this.state.showEscalationOptionsArr
                    );
                    showEscalationOptionsArr[level] = true;
                    this.setState({ showEscalationOptionsArr }, () =>
                      this.props.getTicketingUsers(val)
                    );
                  }}
                />
              </div>
            ) : (
              <div className={`${styles.levelWrapper}`}>
                {this.props.escalationMap &&
                this.props.escalationMap[level] &&
                this.props.escalationMap[level].length ? (
                  <table className={`${styles.memberTable}`}>
                    <tbody>
                      {this.props.escalationMap[level].map((user, id) => (
                        <tr key={id}>
                          <td className={`${styles.memberData}`}>{user}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  "None"
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  renderForm() {
    const { ticketingUsers } = this.props.buSettingsState;
    const { groupTypes } = this.props.categorySettingsState;
    return (
      <div>
        <div
          className={`${styles.utilityBar} ${styles.heading} l-row a-center`}
        >
          <h2>Category</h2>
        </div>
        <div className={`${styles.select}`}>
          <BasicSelect
            optionsArrOfObj={this.getGroupTypeOptions(groupTypes)}
            selectedOpt={
              this.props.group ? this.props.group.groupTypeDTO.name : null
            }
            onSelect={(val, event) => {
              this.setState({
                groupTypeId: event.id
              });
            }}
            label="Select Category"
            enableSearch={true}
          />
        </div>
        {this.props.location.locationCode === "HQTR" && (
          <div>
            <div
              className={`${styles.utilityBar} ${styles.heading} l-row a-center`}
            >
              <h2>Lead of Group</h2>
            </div>
            <div className={`${styles.select}`}>
              <BasicSelect
                optionsArrOfObj={
                  ticketingUsers.isLoaded
                    ? this.getUserOptions(ticketingUsers.data)
                    : []
                }
                selectedOpt={
                  this.props.group
                    ? this.props.group.groupLead &&
                      this.props.group.groupLead.name
                    : null
                }
                onSelect={(val, event) =>
                  this.setState({
                    groupLeadId: event.id,
                    showGroupLeadOptions: false
                  })
                }
                label="Select email address of Group Lead"
                enableSearch={true}
                onChangeInput={val => {
                  this.setState(
                    {
                      showGroupLeadOptions: true
                    },
                    () => {
                      this.props.getTicketingUsers(val);
                    }
                  );
                }}
                showOptions={this.state.showGroupLeadOptions}
              />
            </div>
          </div>
        )}
        <div
          className={`${styles.utilityBar} ${styles.heading} l-row a-center`}
        >
          <h2>Members of Group</h2>
        </div>
        {this.props.location.locationCode === "HQTR" ? (
          <div className={`${styles.select}`}>
            <SelectWithAdd
              placeholder="Enter email address of Members"
              options={
                this.props.buSettingsState.ticketingUsers.isLoaded
                  ? this.getUserOptions(
                      this.props.buSettingsState.ticketingUsers.data
                    )
                  : []
              }
              onSelectOption={allValues => {
                this.setState({ userIdList: allValues });
              }}
              onChangeInput={val => this.props.getTicketingUsers(val)}
              idAccessor="id"
              selectedOptions={this.props.group && this.props.group.userDTOList}
            />
          </div>
        ) : (
          <div className={`${styles.select}`}>
            <table className={`${styles.memberTable}`}>
              <tbody>
                {this.props.members &&
                  this.props.members.length &&
                  this.props.members.map((user, id) => (
                    <tr key={id}>
                      <td className={`${styles.memberData}`}>{user}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="l-row">
        <div className={`${styles.initialUtilityBar} ${styles.leftPane}`}>
          <div className={`${styles.utilityBar}`}>
            <h1>Resolver Group details</h1>
          </div>
          <div>{this.renderForm()}</div>
        </div>
        <div className={`${styles.initialUtilityBar} ${styles.rightPane}`}>
          <div className={`${styles.utilityBar}`}>
            <h1>Escalation</h1>
            <div>{this.renderEscalationForm()}</div>
          </div>
          <div
            className={`l-row flex-100 ${styles.btnWrapper}`}
            onClick={() => this.onSubmit()}
          >
            <div className={`${styles.btnText} l-row a-center j-center`}>
              Submit
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResolverGroup.defaultProps = {
  group: null
};

const mapStateToProps = state => ({
  resolverGroupState: state.resolverGroupState,
  userProfile: state.userProfile,
  categorySettingsState: state.categorySettingsState,
  buSettingsState: state.buSettingsState
});

const mapDispatchToProps = dispatch => ({
  createGroupSubmit: bindActionCreators(createGroupSubmit, dispatch),
  getGroupTypesByBu: bindActionCreators(getGroupTypesByBu, dispatch),
  getTicketingUsers: bindActionCreators(getTicketingUsers, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ResolverGroup);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/resolverGroup/resolverGroup.js